import React from "react";
import { DevContainer, IgorContainer } from "../Home/style";
import foto from "../../assets/foto.jpg";
import { Container, PContainer, ProgressBarContainer } from "./style";

import { ProgressBar } from "../ProgressBar";

export const WhoIAm = () => {
  const FrontTechs = [
    {
      name: "HTML 5 | CSS 3 | JavaScript",
      percentage: 100,
    },
    {
      name: "ReactJS | Redux | ContextAPI",
      percentage: 90,
    },
    {
      name: "TypeScript",
      percentage: 60,
    },
    {
      name: "Styled Components | Chakra-UI",
      percentage: 80,
    },
  ];

  const BackTechs = [
    {
      name: "SQL | Postgres",
      percentage: 60,
    },
    {
      name: "Node.JS | TypeORM",
      percentage: 70,
    },
    {
      name: "Nest.JS | Express | Prisma",
      percentage: 40,
    },
    {
      name: "Python | Django",
      percentage: 50,
    },
  ];

  return (
    <Container>
      <IgorContainer>
        <img src={foto} alt="Igor Garcia" />
      </IgorContainer>
      <DevContainer>
        <h2>OLÁ, TUDO BEM</h2>
        <h2>COM VOCÊS?</h2>
      </DevContainer>
      <PContainer>
        <p>
          Olá, meu nome é Igor Garcia, tenho 31 anos e{" "}
          <span> sou apaixonado por tecnologia.</span>
        </p>
        <p>
          Com 5 anos, minha mãe apresentou o computador pra mim e me ensinou os
          primeiros passos e desde então, nunca mais parei.
        </p>
        <p>
          O meu primeiro contato com a programação foi com 14 anos mIRC
          scripting para canais de RPG.{" "}
          <span>
            {" "}
            Depois disso a tecnologia e tudo que o envolve se tornou minha
            paixão.
          </span>
        </p>
        <p>
          Apésar de formado em Engenharia Ambiental pela Universidade Federal do
          Triângulo Mineiro, percebi que não era o que eu queria.
        </p>
        <p>
          Então em 2022, decidi abandonar a engenharia para entrar de cabeça no
          desenvolvimento web proporcionado pela Kenzie Academy Brasil.
        </p>
        <p>
          <span>Atualmente sou Desenvolvedor Full-Stack Jr.</span>
        </p>
      </PContainer>
      <h2>Front-End</h2>
      <ProgressBarContainer>
        {FrontTechs.map((tech, index) => (
          <ProgressBar value={tech.percentage} key={index}>
            {tech.name}
          </ProgressBar>
        ))}
      </ProgressBarContainer>
      <h2>Back-End</h2>
      <ProgressBarContainer>
        {BackTechs.map((tech, index) => (
          <ProgressBar value={tech.percentage} key={index}>
            {tech.name}
          </ProgressBar>
        ))}
      </ProgressBarContainer>
    </Container>
  );
};
